import React from 'react'
import { Badge } from './ManualBadge.styles'

export const ManualBadge = ({ isRostered }) => {
  return !isRostered ? <Badge>Manual</Badge> : <React.Fragment />
}